<template>
    <div class="map-section">
        <div class="container">
            <div class="row">
                <div class="map">
                    <GoogleMap :zoom="4.5" :showPinData="getIsLogged" :listData="getMapData" />

                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoogleMap from '@/ui/google-map/GoogleMap'

export default {
    name: 'MapSection',
    components: { GoogleMap },
    computed: {
        getMapData() {
            return this.$store.state.mapData
        },
        getIsLogged() {
            return this.$store.state.isLogged
        }
    }
}
</script>

<style scope src="./MapSection-light-theme.css"></style>
<style scope src="./MapSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/map-section/MapSection.vue